import { api } from './client'

// ─── Formulir (admin) ────────────────────────────────────────────────────────

export const listAppraisalForms = () =>
  api.get('/appraisals/forms').then((r) => r.data)
export const getAppraisalForm = (id) =>
  api.get(`/appraisals/forms/${id}`).then((r) => r.data)
export const createAppraisalForm = (data) =>
  api.post('/appraisals/forms', data).then((r) => r.data)
export const updateAppraisalForm = (id, data) =>
  api.put(`/appraisals/forms/${id}`, data).then((r) => r.data)
export const deleteAppraisalForm = (id) =>
  api.delete(`/appraisals/forms/${id}`).then((r) => r.data)
export const duplicateAppraisalForm = (id) =>
  api.post(`/appraisals/forms/${id}/duplicate`).then((r) => r.data)

// Butir disimpan borongan, bukan satu per satu: mengurutkan ulang dan mengubah
// bobot menyentuh banyak baris sekaligus.
export const saveAppraisalItems = (id, items) =>
  api.put(`/appraisals/forms/${id}/items`, { items }).then((r) => r.data)

// ─── Penugasan (admin) ───────────────────────────────────────────────────────

export const assignFromProgram = (formId, data) =>
  api.post(`/appraisals/forms/${formId}/requests`, data).then((r) => r.data)

// Nama diketik langsung, tanpa peserta program dan tanpa berkas Excel — untuk
// orang yang dinilai tapi tidak pernah ikut pelatihan apa pun.
export const assignManual = (formId, data) =>
  api.post(`/appraisals/forms/${formId}/requests/manual`, data).then((r) => r.data)

export const importAppraisalSubjects = (formId, file, extra = {}) => {
  const formData = new FormData()
  formData.append('file', file)
  for (const [k, v] of Object.entries(extra)) if (v != null) formData.append(k, v)
  return api
    .post(`/appraisals/forms/${formId}/requests/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

export const listAppraisalRequests = (params = {}) =>
  api.get('/appraisals/requests', { params }).then((r) => r.data)
export const getAppraisalRequest = (id) =>
  api.get(`/appraisals/requests/${id}`).then((r) => r.data)
export const resendAppraisal = (id) =>
  api.post(`/appraisals/requests/${id}/resend`).then((r) => r.data)
export const cancelAppraisal = (id) =>
  api.delete(`/appraisals/requests/${id}`).then((r) => r.data)

// Nyalakan atau matikan tautan penilaian. Mematikan TIDAK membatalkan
// penilaiannya — yang sudah diisi tetap sah.
export const setAppraisalLink = (id, active) =>
  api.post(`/appraisals/requests/${id}/link`, { active }).then((r) => r.data)

// Tautan penilaian sebagai QR — untuk dicetak atau ditunjukkan di layar.
// Isinya TOKEN, bukan alamat publik, jadi jangan disebar sembarangan.
export const appraisalQr = (id) =>
  api.get(`/appraisals/requests/${id}/qr`).then((r) => r.data)

// ─── Penilai berakun (trainer) ───────────────────────────────────────────────

export const myAppraisals = () =>
  api.get('/appraisals/mine').then((r) => r.data)
export const saveMyAppraisalAnswers = (id, body) =>
  api.put(`/appraisals/requests/${id}/answers`, body).then((r) => r.data)
export const submitMyAppraisal = (id, body) =>
  api.post(`/appraisals/requests/${id}/submit`, body).then((r) => r.data)

// ─── Penilai bertautan (tanpa akun) ──────────────────────────────────────────
//
// Tanpa Authorization header — tokennya sendiri yang menjadi kuncinya. Kalau
// interceptor axios kelak menambahkan token kedaluwarsa ke permintaan ini, ia
// tetap tidak berpengaruh: backend tidak membaca header itu di jalur ini.

export const getAppraisalByToken = (token) =>
  api.get(`/appraisals/by-token/${token}`).then((r) => r.data)
export const saveAppraisalByToken = (token, body) =>
  api.put(`/appraisals/by-token/${token}/answers`, body).then((r) => r.data)
export const submitAppraisalByToken = (token, body) =>
  api.post(`/appraisals/by-token/${token}/submit`, body).then((r) => r.data)

// ─── Ekspor ──────────────────────────────────────────────────────────────────
//
// Nama berkas datang dari header Content-Disposition milik server, bukan disusun
// ulang di sini — dua tempat yang menyusun nama yang sama pasti akan berbeda
// suatu saat.

function namaDariHeader(res, cadangan) {
  const cd = res.headers?.["content-disposition"] || ""
  const m = /filename="?([^";]+)"?/i.exec(cd)
  return m ? decodeURIComponent(m[1]) : cadangan
}

/** Seluruh penilaian sebuah formulir: csv | xlsx | pdf. */
export const downloadAppraisalExport = (formId, format = "csv") =>
  api
    .get(`/appraisals/forms/${formId}/export.${format}`, { responseType: "blob" })
    .then((r) => ({ blob: r.data, filename: namaDariHeader(r, `penilaian.${format}`) }))

/** Satu penilaian sebagai lembar PDF — untuk diarsipkan atau dilampirkan. */
export const downloadAppraisalPdf = (requestId) =>
  api
    .get(`/appraisals/requests/${requestId}/export.pdf`, { responseType: "blob" })
    .then((r) => ({ blob: r.data, filename: namaDariHeader(r, "penilaian.pdf") }))
